import { PayloadAction } from "@reduxjs/toolkit";
import { ValentineState } from "../types";

const ValentineReducer = {
  setImageName: (state: ValentineState, action: PayloadAction<string>) => {
    state.imageName = action.payload;
  },
  setIsImageGenerating: (state: ValentineState, action: PayloadAction<boolean>) => {
    state.isImageGenerating = action.payload;
  },
  setIsOpenShareModal: (state: ValentineState, action: PayloadAction<boolean>) => {
    state.isOpenShareModal = action.payload;
  },
  setIsValentineModalOpen: (state: ValentineState, action: PayloadAction<boolean>) => {
    state.isOpenValentineModal = action.payload;
  },
  setError: (state: ValentineState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
};

export default ValentineReducer;
